import { AlertTriangle } from 'lucide-react';
import { Modal } from '../../components/Modal';
import { formatMoeda } from '@fiodecobre/shared';
import { ApiError } from '../../lib/api';

// Payload do 409 da trava anti-negativo (responderSaldoInsuficiente, caixa.routes.ts).
export interface SaldoInsuficiente {
  caixa_nome: string;
  saldo_atual: number;
  valor_solicitado: number;
  falta: number;
}

// Le o corpo do erro e devolve o payload SO quando for a trava de saldo. Qualquer outro erro
// volta null, pra quem chamou seguir com o tratamento normal.
export function lerSaldoInsuficiente(e: unknown): SaldoInsuficiente | null {
  if (!(e instanceof ApiError) || e.status !== 409) return null;
  const c = e.corpo;
  if (!c || c.codigo !== 'SALDO_INSUFICIENTE') return null;
  return {
    caixa_nome: String(c.caixa_nome ?? 'caixa'),
    saldo_atual: Number(c.saldo_atual ?? 0),
    valor_solicitado: Number(c.valor_solicitado ?? 0),
    falta: Number(c.falta ?? 0),
  };
}

// MODAL, nao toast. A operacao foi RECUSADA e o dinheiro nao se mexeu — se essa mensagem passar
// batida, a pessoa acha que pagou/transferiu e o descompasso comeca ali. Foi assim que o
// "turno continua aberto" da conferencia passou despercebido (12px cinza) e a gaveta da Rafaela
// amanheceu aberta.
export function SaldoInsuficienteModal({ info, onFechar }: { info: SaldoInsuficiente; onFechar: () => void }) {
  return (
    <Modal
      aberto
      onFechar={onFechar}
      titulo="Operação recusada — saldo insuficiente"
      largura={480}
      compacto
      rodape={<button type="button" className="btn-primario" onClick={onFechar}>Entendi</button>}
    >
      <div style={{ display: 'grid', gap: 12 }}>
        <div style={{
          display: 'flex', gap: 8, alignItems: 'flex-start',
          backgroundColor: '#fee2e2', border: '1px solid #ef4444', borderRadius: 6, padding: '10px 12px',
        }}>
          <AlertTriangle size={18} style={{ color: '#b91c1c', flexShrink: 0, marginTop: 1 }} />
          <span style={{ fontSize: 13, color: '#000', lineHeight: 1.45 }}>
            <strong>Nada foi lançado.</strong> Esta operação deixaria <strong>{info.caixa_nome}</strong> com
            saldo negativo, e caixa não pode ficar negativo.
          </span>
        </div>

        <div style={{ display: 'grid', gap: 6, fontSize: 14 }}>
          <Linha rotulo="Disponível no caixa" valor={formatMoeda(info.saldo_atual)} />
          <Linha rotulo="A operação pede" valor={formatMoeda(info.valor_solicitado)} />
          <Linha rotulo="Faltam" valor={formatMoeda(info.falta)} destaque />
        </div>

        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', lineHeight: 1.5, margin: 0 }}>
          Saldo negativo quer dizer que saiu dinheiro que nunca foi registrado entrando. Antes de
          repetir, registre a <strong>entrada</strong> do dinheiro nesse caixa — por suprimento ou por
          transferência de outro caixa (Cofre, por exemplo). Depois refaça a operação.
        </p>
      </div>
    </Modal>
  );
}

function Linha({ rotulo, valor, destaque }: { rotulo: string; valor: string; destaque?: boolean }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
      <span style={{ color: 'var(--text-muted)' }}>{rotulo}</span>
      <span style={{ fontWeight: destaque ? 700 : 600, color: destaque ? '#b91c1c' : undefined }}>{valor}</span>
    </div>
  );
}
